import React, { FC, ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { TranslationKey } from '@lang';
import { TypographyGenerator } from './TypographyGenarator';

type TypographyProps = {
  children?: ReactNode;
  textId?: TranslationKey;
  tag?: string;
  strong?: boolean;
  uppercase?: boolean;
  color?: string;
};

export const Heading1: FC<TypographyProps> = ({ ...props }) => {
  const { customColors, headerFont, spaces, typography } = useTheme();

  return (
    <TypographyGenerator
      typographySizes={typography.heading1}
      color={customColors.primary}
      marginBottom={spaces.space6}
      font={headerFont}
      {...props}
    />
  );
};

export const Heading2: FC<TypographyProps> = ({ ...props }) => {
  const { customColors, headerFont, spaces, typography } = useTheme();

  return (
    <TypographyGenerator
      typographySizes={typography.heading2}
      color={customColors.primary}
      marginBottom={spaces.space6}
      font={headerFont}
      {...props}
    />
  );
};

export const Heading3: FC<TypographyProps> = (props) => {
  const { customColors, headerFont, spaces, typography } = useTheme();

  return (
    <TypographyGenerator
      typographySizes={typography.heading3}
      color={customColors.primary}
      marginBottom={spaces.space6}
      font={headerFont}
      {...props}
    />
  );
};

export const Heading4: FC<TypographyProps> = (props) => {
  const { customColors, headerFont, spaces, typography } = useTheme();

  return (
    <TypographyGenerator
      typographySizes={typography.heading4}
      color={customColors.primary}
      marginBottom={spaces.space6}
      font={headerFont}
      {...props}
    />
  );
};

export const Title1: FC<TypographyProps> = (props) => {
  const { customColors, headerFont, spaces, typography } = useTheme();

  return (
    <TypographyGenerator
      typographySizes={typography.title1}
      color={customColors.primary}
      marginBottom={spaces.space5}
      font={headerFont}
      {...props}
    />
  );
};

export const Title2: FC<TypographyProps> = (props) => {
  const { headerFont, typography } = useTheme();

  return <TypographyGenerator typographySizes={typography.title2} font={headerFont} {...props} />;
};

export const Title3: FC<TypographyProps> = (props) => {
  const { headerFont, typography } = useTheme();

  return <TypographyGenerator typographySizes={typography.title3} font={headerFont} {...props} />;
};

export const Title4: FC<TypographyProps> = (props) => {
  const { headerFont, typography } = useTheme();

  return <TypographyGenerator typographySizes={typography.title4} font={headerFont} {...props} />;
};

export const Body1: FC<TypographyProps> = (props) => {
  const { typography } = useTheme();

  return <TypographyGenerator typographySizes={typography.body1} {...props} />;
};

export const Body2: FC<TypographyProps> = (props) => {
  const { typography } = useTheme();

  return <TypographyGenerator typographySizes={typography.body2} {...props} />;
};

export const Body3: FC<TypographyProps> = (props) => {
  const { typography } = useTheme();

  return <TypographyGenerator typographySizes={typography.body3} {...props} />;
};

export const Body4: FC<TypographyProps> = (props) => {
  const { typography } = useTheme();

  return <TypographyGenerator typographySizes={typography.body4} {...props} />;
};
